import { gql } from '@apollo/client';

export const getJournalEntryQuery = gql`
    query GetJournalEntry($id: String!) {
        journalEntry(id: $id) {
            id
            text
            rating
            ritualId
            ritualType
            taskName
            promptText
            createdAt
        }
    }
`;
